import { URLs } from "@/constants";
import type { IAnalyticsData, IApiRequest } from "@/types";
import { apiURL, flatten, sendRequest, sendRequestWithAnalyzeAllPolling } from "@/utils";

namespace BirdEyeAction {
  export const getAnalyticsData = async <T extends IApiRequest.BirdEyeAnalyzeInput>(
    userId: string,
    customerId: string,
    accountId: string,
    payload: T
  ) => {
    return await sendRequest<{
      data: T["type"] extends IAnalyticsData.BirdEyeAnalyticsType.ReviewsAndRatings
        ? Array<IAnalyticsData.IBirdEyeReviewsAndRatingsAnalyze>
        : T["type"] extends IAnalyticsData.BirdEyeAnalyticsType.ReviewsDistribution
          ? Array<IAnalyticsData.IBirdEyeReviewsDistributionAnalyze>
          : T["type"] extends IAnalyticsData.BirdEyeAnalyticsType.ResponseRate
            ? Array<IAnalyticsData.IBirdEyeResponseRateAnalyze>
            : T["type"] extends IAnalyticsData.BirdEyeAnalyticsType.ReviewsAndRatingsBySource
              ? Array<IAnalyticsData.IBirdEyeReviewsAndRatingsBySourceAnalyze>
              : T["type"] extends IAnalyticsData.BirdEyeAnalyticsType.Listings
                ? Array<IAnalyticsData.IBirdEyeListingsAnalyze>
                : T["type"] extends IAnalyticsData.BirdEyeAnalyticsType.DirectoryListings
                  ? IAnalyticsData.IBirdEyeDirectoryListings
                  : never;
    }>({
      url: apiURL(URLs.API_BIRD_EYE_ANALYTICS(userId, customerId, accountId)),
      method: "GET",
      params: payload
    });
  };
  export const getAllAnalyticsData = async (
    userId: string,
    customerId: string,
    accountId: string,
    payload: {
      startMonth: string;
      endMonth: string;
      comparedStartMonth: string;
      comparedEndMonth: string;
    }
  ) => {
    return await sendRequestWithAnalyzeAllPolling<{
      "reviews-and-ratings": Array<IAnalyticsData.IBirdEyeReviewsAndRatingsAnalyze> | null;
      "reviews-and-ratings-compared": Array<IAnalyticsData.IBirdEyeReviewsAndRatingsAnalyze> | null;
      "reviews-distribution": Array<IAnalyticsData.IBirdEyeReviewsDistributionAnalyze> | null;
      "reviews-distribution-compared": Array<IAnalyticsData.IBirdEyeReviewsDistributionAnalyze> | null;
      "response-rate": Array<IAnalyticsData.IBirdEyeResponseRateAnalyze> | null;
      "response-rate-compared": Array<IAnalyticsData.IBirdEyeResponseRateAnalyze> | null;
      "reviews-and-ratings-by-source": Array<IAnalyticsData.IBirdEyeReviewsAndRatingsBySourceAnalyze> | null;
      listings: Array<IAnalyticsData.IBirdEyeListingsAnalyze> | null;
      "listings-compared": Array<IAnalyticsData.IBirdEyeListingsAnalyze> | null;
      "directory-listings": IAnalyticsData.IBirdEyeDirectoryListings | null;
    }>({
      url: apiURL(URLs.API_BIRD_EYE_ANALYZE_ALL(userId, customerId, accountId)),
      method: "GET",
      params: flatten(payload)
    });
  };
}

export default BirdEyeAction;
